var vars = require('./core');

module.exports = vars.createClass('Radar', ['getPointsAtEvent']);



//////////////////
// WEBPACK FOOTER
// ./~/react-chartjs/lib/radar.js
// module id = 1053
// module chunks = 0